var path = '/glow/component/glow-module/module-ugc/component/ugc-modal/tpl/ugc-modal-modal.html';
var html = "<div class=\"modal-body ugc-modal\" aria-label={{$ctrl.parentScope.ariaLabel}} ng-style=$ctrl.styles.wrapper> <h2 id=modal-title ng-style=$ctrl.styles.submissionFormTitle ng-bind-html=\"$ctrl.parentScope.submissionFormTitle | trustHtml\"></h2> <p id=modal-description ng-style=$ctrl.styles.submissionFormDescription ng-bind-html=\"$ctrl.parentScope.submissionFormDescription | trustHtml\"></p> <ng-include src=\"'/common/formly/formly.tpl.html'\"></ng-include> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-ugc/component/ugc-modal/tpl/ugc-modal-modal.html
// module id = 1773
// module chunks = 1